
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import IconInput from './IconInput';
import { Mail, Lock } from 'lucide-react';
import RememberMeCheckbox from './RememberMeCheckbox';
import { UseFormReturn } from 'react-hook-form';
import { LoginFormValues } from './LoginFormContext';
import SimpleCaptcha from '@/components/auth/SimpleCaptcha';

interface LoginFormFieldsProps {
  form: UseFormReturn<LoginFormValues>;
  onCaptchaGenerate?: (text: string) => void;
  showCaptcha?: boolean;
}

const LoginFormFields: React.FC<LoginFormFieldsProps> = ({
  form,
  onCaptchaGenerate,
  showCaptcha = false
}) => {
  return (
    <>
      <div className="space-y-5">
        <FormField 
          control={form.control} 
          name="email" 
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-sm font-semibold">Email</FormLabel>
              <FormControl>
                <IconInput 
                  placeholder="Enter your email" 
                  type="email" 
                  icon={Mail} 
                  className="h-11" 
                  {...field} 
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )} 
        />
        
        <FormField 
          control={form.control} 
          name="password" 
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-sm font-semibold">Password</FormLabel>
              <FormControl>
                <IconInput 
                  placeholder="Enter your password" 
                  type="password" 
                  icon={Lock} 
                  showPasswordToggle 
                  className="h-11" 
                  {...field} 
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )} 
        />
      </div>
      
      <div className="mt-4 mb-4">
        <FormField 
          control={form.control} 
          name="rememberMe" 
          render={({ field }) => (
            <RememberMeCheckbox field={field} />
          )} 
        />
      </div>
      
      {showCaptcha && (
        <FormField 
          control={form.control} 
          name="captcha" 
          render={({ field }) => (
            <FormItem className="mb-4">
              <FormLabel className="text-sm font-semibold">Security Check</FormLabel>
              <div className="space-y-2">
                <SimpleCaptcha onGenerate={onCaptchaGenerate || (() => {})} />
                <FormControl>
                  <Input 
                    {...field} 
                    placeholder="Enter the text shown above" 
                    autoComplete="off" 
                    className="h-11" 
                  />
                </FormControl>
              </div>
              <FormMessage />
            </FormItem>
          )} 
        />
      )}
    </>
  );
};

export default LoginFormFields;
